module.exports = "<div class=\"sie-notification\">\r\n  <a class=\"sie-notification-close\">关闭</a>\r\n  <h4 class=\"sie-notification-title\">弹窗标题</h4>\r\n  <p class=\"sie-notification-msg\">\r\n    弹窗内容\r\n  </p>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// E:/project/muyiwang/svn/project-code/trad-portal/src/app/components/notification/notification.component.html
// module id = ../../../../../src/app/components/notification/notification.component.html
// module chunks = main